import { useEffect, useRef, useState } from 'react';
import Modal from './Modal';
import { buildPublicFormPreviewSchema, loadPublicFormPreviewDocument } from '../utils/publicFormPreview';

const PublicFormPreview = ({ draft, onClose }) => {
  const [documentSource, setDocumentSource] = useState('');
  const [error, setError] = useState('');
  const closeRef = useRef(null);
  useEffect(() => {
    const previousFocus = document.activeElement;
    closeRef.current?.focus();
    const controller = new AbortController();
    let active = true;
    loadPublicFormPreviewDocument(buildPublicFormPreviewSchema(draft), controller.signal)
      .then((value) => { if (active) setDocumentSource(value); })
      .catch((failure) => { if (active) setError(failure.message || 'Preview could not be loaded.'); });
    return () => {
      active = false;
      controller.abort();
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [draft]);
  return (
    <Modal onClose={onClose} title="Recipient preview" instructions="Includes unsaved draft changes. Nothing is saved or sent. Do not enter client information."
      header={<div className='modal-header-actions'>
        <button ref={closeRef} type="button" className="action quaternary" onClick={onClose}>Close preview</button>
      </div>}
      wide
    >
      <div className="modal-content-wrapper public-form-preview">
        {error ? <p role="alert">{error}</p> : documentSource ? (
          <iframe
            title="Recipient form preview — no changes saved"
            className="public-form-preview-frame"
            sandbox="allow-scripts"
            referrerPolicy="no-referrer"
            srcDoc={documentSource}
          />
        ) : <p role="status">Loading recipient preview…</p>}
      </div>
    </Modal>
  );
};
export default PublicFormPreview;
